module.exports = __webpack_public_path__ + "img/ic_no_language.63de87fe.svg";